import ActionPage from "./ActionPage";

export default ActionPage;
